import React from 'react';
import styles from './styles.module.css';

const ToastSpinner = () => (
  <div className="d-flex align-items-center">
    <div className={styles.grid}>
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
    <span className="ms-2 fs-5 text-dark">Generating Design ...</span>
  </div>
);

export default ToastSpinner;
